(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-eg-cookie-preferences]');
    if (!button) return;

    var status = document.getElementById(button.getAttribute('aria-describedby'));
    status.hidden = true;
    status.textContent = '';
    button.disabled = true;

    Promise.resolve().then(function() {
      if (!window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') {
        throw new Error('Shopify privacy banner is unavailable');
      }
      return window.privacyBanner.showPreferences();
    }).catch(function() {
      status.textContent = button.getAttribute('data-error-message');
      status.hidden = false;
    }).finally(function() {
      button.disabled = false;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
